import { render, staticRenderFns } from "./ResumenVentanas.vue?vue&type=template&id=1bbe63bc&"
import script from "./ResumenVentanas.vue?vue&type=script&lang=js&"
export * from "./ResumenVentanas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports